<div *ngIf="errorMessage.length > 0" class="hcm-alert-message">
  <div class="hcm-alert-message-text" *ngFor="let error of errorMessage">
    {{ error }}
  </div>
</div>